// extracted by mini-css-extract-plugin
module.exports = {"two":"index-module--two--1DQOE","logolist":"index-module--logolist--2RcDQ","flex":"index-module--flex--9c185","figure":"index-module--figure--3Q15c"};